import { useTranslation } from "react-i18next";
import styles from "./StatusObservation.module.scss";
import { useEffect, useState } from "react";
import { IconButton } from "@mui/material";
import { EditIcon } from "../../../assets/icons";


interface Props {
  statusCode: number;
  action: () => void;
  disabled: boolean;
}

const StatusObservation: React.FC<Props> = ({ statusCode, action, disabled }) => {
  const { t } = useTranslation();
  const [statusName, setStatusName] = useState<string>("Pending");

  useEffect(() => {
    if (statusCode === 0) {
      setStatusName("Pending");
    }
    else if (statusCode === 1) {
      setStatusName("Resolved");
    }
  }, [statusCode]);

  return (
    <>
      <div className={styles.base + " " + styles[statusName]}>
        <div>{t(`statusObservation.${statusName}`)}</div>
      </div>
      {statusCode === 0 &&
        <div className={styles.iconButton}>
          <IconButton
            disabled={disabled}
            onClick={action}
          >
            <EditIcon />
          </IconButton>
        </div>
      }
    </>
  );
};

export default StatusObservation;
